<template>
  <BNavItemDropdown
    v-if="
      userData &&
      ((unreadNotificationsList && unreadNotificationsList.length) ||
        (readNotificationsList && readNotificationsList.length))
    "
    class="dropdown-notification mr-25"
    menu-class="dropdown-menu-media"
    right
  >
    <template #button-content>
      <FeatherIcon
        :badge="userData.unReadNotificationCount"
        badge-classes="bg-danger font-weight-normal"
        class="text-body"
        icon="BellIcon"
        size="21"
      />
    </template>

    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">اطلاعیه ها</h4>
        <BBadge pill variant="light-primary">
          {{ userData.unReadNotificationCount }} جدید
        </BBadge>
      </div>
    </li>

    <!-- Notifications -->
    <BTabs align="center" justified class="w-100">
      <BTab class="p-1" title="خوانده نشده" active title-link-class="p-1">
        <VuePerfectScrollbar
          v-once
          :settings="perfectScrollbarSettings"
          class="scrollable-container media-list scroll-area"
          tagname="li"
        >
          <!-- Account Notification -->
          <template
            v-if="unreadNotificationsList && unreadNotificationsList.length"
          >
            <li
              @click="renderNotificationDetails(notification)"
              v-for="(notification, index) in unreadNotificationsList"
              :key="index"
              class="cursor-pointer"
            >
              <BMedia>
                <template #aside>
                  <BAvatar
                    size="32"
                    :src="notification.avatar"
                    :text="notification.avatar"
                    :variant="notification.type"
                    :badge="!notification.isRead"
                    class="badge-minimal"
                    badge-variant="danger"
                  >
                    <FeatherIcon
                      size="20"
                      :icon="
                        notification.isRead
                          ? 'CheckCircleIcon'
                          : 'AlertOctagonIcon'
                      "
                    />
                  </BAvatar>
                </template>
                <p class="media-heading">
                  <span class="font-weight-bolder">
                    {{ notification.title }}
                  </span>
                </p>
                <div style="margin-right: 5px; margin-top: 5px">
                  <small class="notification-text">
                    <FeatherIcon icon="ClockIcon" />
                    {{ notification.subtitle }}
                  </small>
                </div>
              </BMedia>
            </li>
          </template>
          <template v-else>
            <p class="text-center">هیچ موردی یافت نشد</p>
          </template>
        </VuePerfectScrollbar>
      </BTab>
      <BTab title="خوانده شده" title-link-class="p-1">
        <VuePerfectScrollbar
          v-once
          :settings="perfectScrollbarSettings"
          class="scrollable-container media-list scroll-area"
          tagname="li"
        >
          <!-- Account Notification -->
          <template
            v-if="readNotificationsList && readNotificationsList.length"
          >
            <li
              @click="renderNotificationDetails(notification)"
              v-for="(notification, index) in readNotificationsList"
              :key="index"
              class="cursor-pointer"
            >
              <BMedia>
                <template #aside>
                  <BAvatar
                    size="32"
                    :src="notification.avatar"
                    :text="notification.avatar"
                    :variant="notification.type"
                    :badge="false"
                    class="badge-minimal"
                    badge-variant="danger"
                  >
                    <FeatherIcon size="20" icon="CheckCircleIcon" />
                  </BAvatar>
                </template>
                <p class="media-heading">
                  <span class="font-weight-bolder">
                    {{ notification.title }}
                  </span>
                </p>
                <div style="margin-right: 5px; margin-top: 5px">
                  <small class="notification-text">
                    <FeatherIcon icon="ClockIcon" />
                    {{ notification.subtitle }}
                  </small>
                </div>
              </BMedia>
            </li>
          </template>
          <template v-else>
            <p class="text-center">هیچ موردی یافت نشد</p>
          </template>
        </VuePerfectScrollbar>
      </BTab>
    </BTabs>
  </BNavItemDropdown>
</template>

<script>
export default {
  emits: ["renderNotificationDetails"],
  mounted() {
    this.getNotificationsList();
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      unreadNotificationsList: null,
      readNotificationsList: null,
      totalCount: null,
      notificationFilters: {
        pageNumber: 1,
        count: 10,
        userId: null,
      },
      perfectScrollbarSettings: {
        maxScrollbarLength: 60,
        wheelPropagation: false,
      },
    };
  },
  methods: {
    renderNotificationDetails(notificationDetails) {
      this.$emit("renderNotificationDetails", notificationDetails);
    },
    async getNotificationsList() {
      try {
        this.notificationFilters.userId = this.userData.userId;
        const _this = this;
        const getSystemNotificationsByUserId = new GetSystemNotificationsForUI(
          _this
        );
        getSystemNotificationsByUserId.setRequestParam(
          _this.notificationFilters
        );
        await getSystemNotificationsByUserId.fetch((res) => {
          _this.readNotificationsList = res.data.data.readNotification.map(
            (item) => {
              return {
                title: item.subject,
                avatar: "FR",
                subtitle: helper.timeAgo(item.createAt),
                type: "light-success",
                ...item,
              };
            }
          );
          _this.unreadNotificationsList = res.data.data.unReadNotification.map(
            (item) => {
              return {
                title: item.subject,
                avatar: "FR",
                subtitle: helper.timeAgo(item.createAt),
                type: "light-danger",
                ...item,
              };
            }
          );
          // _this.totalCount = res.data.totalCount;
        });
      } catch (error) {
        console.error(error);
      } finally {
      }
    },
  },
  computed: {
    userData() {
      if (getUserData) {
        return getUserData().user;
      }
    },
  },
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,
    VuePerfectScrollbar,
    BButton,
    BFormCheckbox,
    BTabs,
    BTab,
  },
};
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Ripple from "vue-ripple-directive";
import { getUserData } from "@/auth/utils";
import {
  GetSystemNotificationsByUserId,
  GetSystemNotificationsForUI,
} from "@/libs/Api/Notifications";
import helper from "@/libs/Helper";
import {
  BNavItemDropdown,
  BBadge,
  BMedia,
  BLink,
  BAvatar,
  BButton,
  BFormCheckbox,
  BTabs,
  BTab,
} from "bootstrap-vue";
</script>

<style></style>
